import LoaderBuilder from './components/LoaderBuilder';
import { refactorRoute } from './routeConstant';

const postTransplantRoutes = [
    {
        name: 'Theo dõi sau ghép',
        path: refactorRoute.POST_TRANSPLANT_DETAIL,
        component: LoaderBuilder(() => import('view/PostTransplant')),
        children: [
            {
                name: 'Theo dõi sau ghép - Redirect',
                path: refactorRoute.POST_TRANSPLANT_DETAIL,
                component: LoaderBuilder(
                    () => import('view/PostTransplant/Elements/PatientRedirect')
                ),
            },
            {
                name: 'Thông tin hành chính',
                path: refactorRoute.PATIENT_DETAIL_RECEIVED_HANH_CHINH,
                component: LoaderBuilder(
                    () => import('view/PostTransplant/pages/HanhChinh')
                ),
            },
            {
                name: 'Danh sách lần khám sau ghép',
                path: refactorRoute.PATIENT_DETAIL_RECEIVED_VISIT,
                component: LoaderBuilder(
                    () => import('view/PostTransplant/pages/Visit')
                ),
            },
            {
                name: 'Theo dõi sau ghép - Forms',
                path: refactorRoute.PATIENT_DETAIL_RECEIVED_FORMS,
                component: LoaderBuilder(
                    () => import('view/PostTransplant/pages/Form')
                ),
            },
        ],
    },
];

export default postTransplantRoutes;
